/**
 * Figma group 2749:280839 — body 2749:280836 + top-face seam 2749:280837.
 */
export const KG_DATA_MODEL_CUBE_VIEWBOX = "0 0 112 124.42";

/** Rounded hex body (2749:280836), authored in padded coords — shift into viewBox. */
export const KG_DATA_MODEL_CUBE_BODY_PATH =
  "M117.5 42.8206C117.498 40.6383 116.922 38.4949 115.83 36.6056C114.737 34.7162 113.168 33.1473 111.278 32.0561L67.7222 7.16724C65.8304 6.07501 63.6845 5.5 61.5 5.5C59.3155 5.5 57.1696 6.07501 55.2778 7.16724L11.7222 32.0561C9.8323 33.1473 8.26254 34.7162 7.17043 36.6056C6.07831 38.4949 5.50224 40.6383 5.5 42.8206L5.5 92.5984C5.50224 94.7806 6.07831 96.924 7.17043 98.8133C8.26254 100.703 9.8323 102.272 11.7222 103.363L55.2778 128.252C57.1696 129.344 59.3155 129.919 61.5 129.919C63.6845 129.919 65.8304 129.344 67.7222 128.252L111.278 103.363C113.168 102.272 114.737 100.703 115.83 98.8133C116.922 96.924 117.498 94.7806 117.5 92.5984V42.8206Z";

export const KG_DATA_MODEL_CUBE_BODY_OFFSET = { x: -5.5, y: -5.5 } as const;

/**
 * Top-face chevron (2749:280837) — open path only (no Z).
 * Closing with Z strokes a horizontal line through the icon area.
 */
export const KG_DATA_MODEL_CUBE_SEAM_PATH =
  "M0.503356 0.503356L55 31.8233L109.497 0.503356";

/** Seam placement inside the 112×124.42 group (Figma layout). */
export const KG_DATA_MODEL_CUBE_SEAM_OFFSET = { x: 1.87, y: 31.1 } as const;
